<div class="container">
    <div class="container">
        <mat-tab-group>
            <form [formGroup]="formGroup" class="formgroup">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon>timer</mat-icon>
                        Time Zone Settings
                    </ng-template>
                    <div class="form-content">
                        <div>
                            <div>
                                <label>Time Zone</label>
                                <mat-form-field class="fill-available-width min-20" appearance="outline">
                                    <mat-select formControlName="timezone">
                                        <mat-option *ngFor="let timezone of timezonesData.tz2" [value]=timezone.value>
                                            {{ timezone.value }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div>
                                <label>Date Format</label>
                                <mat-form-field class="fill-available-width min-20" appearance="outline">
                                    <mat-select formControlName="dateFormat">
                                        <mat-option *ngFor="let format of dateFormats" [value]="format">{{ format
                                            }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div>
                                <label>Time Format</label>
                                <mat-form-field class="fill-available-width min-20" appearance="outline">
                                    <mat-select formControlName="timeFormat">
                                        <mat-option value="h23">24 Hour Clock</mat-option>
                                        <mat-option value="h11">12-hour clock</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon>straighten</mat-icon>
                        Measurement Units
                    </ng-template>
                    <div class="form-content">
                        <div>
                            <div>
                                <label>Particle Size Unit</label>
                                <mat-form-field class="fill-available-width min-20" appearance="outline">
                                    <mat-select formControlName="particleSizeUnit">
                                        <mat-option value="meter">meter</mat-option>
                                        <mat-option value="centimeter">centimeter</mat-option>
                                        <mat-option value="millimeter">millimeter</mat-option>
                                        <mat-option value="inch">inch</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div>
                                <label>Quantity Unit</label>
                                <mat-form-field class="fill-available-width min-20" appearance="outline">
                                    <mat-select formControlName="quantityUnit">
                                        <mat-option value="meter">meter</mat-option>
                                        <mat-option value="yard">yard</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div>
                                <label>Sieve Size</label>
                                <mat-form-field class="fill-available-width min-20" appearance="outline">
                                    <mat-select formControlName="sieveSize">
                                        <mat-option value="minimum sieve size">minimum sieve size</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div>
                                <label>Particle Size Distribution Model</label>
                                <mat-form-field class="fill-available-width min-20" appearance="outline">
                                    <mat-select formControlName="particleSizeDistributionModel">
                                        <mat-option value="Swebrec">Swebrec</mat-option>
                                        <mat-option value="Kuz-Ram">Kuz-Ram</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon>mail</mat-icon>
                        Email Settings
                    </ng-template>
                    <div class="form-content">
                        <div class="slide-toggle-box">
                            <mat-slide-toggle formControlName="dailySummary" class="example-margin" color="primary"
                                [checked]="user.dailySummaryMail">
                                Send Daily summary Report
                            </mat-slide-toggle>
                        </div>
                    </div>
                </mat-tab>
            </form>
            <mat-tab>
                <ng-template mat-tab-label>
                    Target Interval Settings (User)
                </ng-template>
                <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
                    <mat-tab label="Custom Sizes ">
                        <target-interval-settings [model]="user" [saveFn]="saveUserTargetSizes" [visibleDeviceDropDown]="visibleDeviceDropDown"></target-interval-settings>
                    </mat-tab>
                </mat-tab-group>
            </mat-tab>
        </mat-tab-group>
        <div class="flex-row center">
            <div class="container">
                <button mat-raised-button color="primary" (click)="saveSettings()" type="submit">
                    Save Settings
                </button>
            </div>
        </div>
    </div>
</div>